module.exports = __webpack_public_path__ + "img/am.6b50213c.svg";